import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {HotkeysDirective} from './hotkeys.directive';
import {HotkeysService} from './hotkeys.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [],
  declarations: [HotkeysDirective],
  exports: [HotkeysDirective]
})
export class HotkeysModule {
}
